import type {
  ErrorToHandle,
  VGLErrorHandlerService,
} from '@/services/errorHandler/types';

export class ConsoleErrorService implements VGLErrorHandlerService {
  handle(error: ErrorToHandle): void {
    console.error(error);
  }
}
